module.exports = __webpack_public_path__ + "img/5.4962d7ca.jpg";